import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";
import { getClientData } from "../../services/auth";
import { useAppContext } from "../../contexts/AppContext";
import Product from "../../types/Product";
import ProductParams from "../../types/ProductParams";

interface ProductsResponse {
  rows: Product[];
  count: number;
  limit: number;
  offset: number;
}

export const useProducts = (
  params?: ProductParams,
  enabled: boolean = true
) => {
  // Usa AppContext para obter o valor da campanha solar
  const { getCampanhaSolarValue } = useAppContext();
  const isCampanhaSolar = getCampanhaSolarValue();
  const clientData = getClientData();
  const cdFabricantePai = clientData?.cd_fabricante_pai || 0;

  // Se não há params, payload é null (como na saga original)
  const payload = params
    ? {
        ...params,
        id_campanha_solar: isCampanhaSolar,
        cdFabricantePai,
      }
    : null;

  return useQuery<ProductsResponse>({
    queryKey: queryKeys.products(payload, isCampanhaSolar),
    queryFn: async () => {
      let response;
      if (payload) {
        response = await api.post<ProductsResponse>("products", payload);
      } else {
        const queryParams = new URLSearchParams({
          id_campanha_solar: isCampanhaSolar,
          cdFabricantePai: String(cdFabricantePai || ""),
        });
        response = await api.get<ProductsResponse>(
          `products?${queryParams.toString()}`
        );
      }
      return response.data;
    },
    enabled,
  });
};
